import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { LoginModule } from './module/login/login.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './shared/interceptors/tokenInterceptor';
import { ApiModule } from './api/identity/api.module';
import { ApiModule as SmsApiModule } from './api/sms-app/api.module';
import { OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';

import { TitleStrategy } from '@angular/router';
import { BrandingTitleStrategy } from './shared/branding/branding-title.strategy';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 1000,
    }),
    LoginModule,
    ApiModule.forRoot({ rootUrl: environment.apiUrlIdentity }),
    SmsApiModule.forRoot({ rootUrl: environment.apiUrlSms }),

    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: TitleStrategy,
      useClass: BrandingTitleStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' },
  ],
  bootstrap: [AppComponent],
  exports: [ToastrModule],
})
export class AppModule {}
